import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { useRouterActions } from 'react-resource-router';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import Button, { ButtonGroup } from '@atlaskit/button';
import PageHeading from '@atlaskit/page-header';
import { fireTrackAnalytics, fireUIAnalytics } from '@atlassian/analytics-bridge';
import { LoadingSpinner } from '@atlassian/proforma-common-core/jira-common';
import { useInProductHelp } from '@atlassian/proforma-common-core/jira-common-context';
import { useTemplateLibraryActions } from '@atlassian/proforma-template-library-store';
import { Action, ActionSubject } from '@atlassian/proforma-utils/analytics';
import { useProjectFormsController } from '../../controllers';
import { useTemplateFormApi } from '../../services/template-form-api';
import { CreateFormSvg } from './assets/create-form-svg';
import { CreateFormDropdown } from './create-form-button';
import { ListProjectForms } from './list';
import { messages } from './messages';
import { Description, HeadingContainer, NoFormsColumn, NoFormsDescription, NoFormsHeading, NoFormsLearnMoreLink, ProjectFormsWrapper } from './styled';
export const ProjectForms = ({
  projectId,
  projectKey,
  projectType,
  simplifiedProject,
  userIsProjectAdmin
}) => {
  const {
    createAnalyticsEvent
  } = useAnalyticsEvents();
  const {
    onOpenInProductHelpArticle
  } = useInProductHelp();
  const [{
    forms,
    loading
  }] = useProjectFormsController();
  const {
    push
  } = useRouterActions();
  const templateFormApi = useTemplateFormApi();
  const {
    setIsTemplateLibraryOpen
  } = useTemplateLibraryActions();
  const [isCreatingForm, setIsCreatingForm] = useState(false);
  const pageHeadingMessage = /*#__PURE__*/React.createElement(FormattedMessage, projectType === 'business' ? messages.pageHeadingJwm : messages.pageHeadingNonJwm);
  if (loading) {
    return /*#__PURE__*/React.createElement(ProjectFormsWrapper, null, /*#__PURE__*/React.createElement(HeadingContainer, null, /*#__PURE__*/React.createElement(PageHeading, null, pageHeadingMessage)), /*#__PURE__*/React.createElement(LoadingSpinner, {
      size: "large"
    }, /*#__PURE__*/React.createElement(FormattedMessage, messages.loading)));
  }
  const createForm = (_, analyticsEvent) => {
    fireUIAnalytics(analyticsEvent, 'createTemplateForm');
    // Call API to create form
    setIsCreatingForm(true);
    templateFormApi.createTemplateFormForProject(projectId, '').then(response => {
      fireTrackAnalytics(createAnalyticsEvent({}), `${ActionSubject.TEMPLATE_FORM} ${Action.CREATED}`, {
        templateFormId: response.id
      });
      push(response.nextUrl);
    }).finally(() => {
      setIsCreatingForm(false);
    });
  };
  const openTemplateLibrary = () => setIsTemplateLibraryOpen(true);
  const learnMoreButton = /*#__PURE__*/React.createElement(Button, {
    appearance: "link",
    spacing: "none",
    onClick: () => onOpenInProductHelpArticle('5TZElbp1tEXG70CGT0HmT4')
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.learnMoreLinkLabel));
  const headingActions = /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(CreateFormDropdown, {
    isLoading: isCreatingForm,
    onCreateBlankForm: createForm,
    onCreateFormFromTemplate: openTemplateLibrary
  }));
  if (forms.length === 0) {
    return /*#__PURE__*/React.createElement(ProjectFormsWrapper, null, /*#__PURE__*/React.createElement(HeadingContainer, null, /*#__PURE__*/React.createElement(PageHeading, {
      actions: headingActions
    }, pageHeadingMessage)), /*#__PURE__*/React.createElement(NoFormsColumn, null, /*#__PURE__*/React.createElement(CreateFormSvg, null), /*#__PURE__*/React.createElement(NoFormsHeading, null, /*#__PURE__*/React.createElement(FormattedMessage, messages.noFormsHeading)), /*#__PURE__*/React.createElement(NoFormsDescription, null, /*#__PURE__*/React.createElement(FormattedMessage, projectType === 'service_desk' ? messages.noFormsDescriptionJsm : projectType === 'software' ? messages.noFormsDescriptionJsw : messages.noFormsDescriptionJwm)), /*#__PURE__*/React.createElement(NoFormsLearnMoreLink, null, learnMoreButton)));
  }
  const bottomBar = /*#__PURE__*/React.createElement(Description, null, /*#__PURE__*/React.createElement(FormattedMessage, messages.description), "\xA0", learnMoreButton);
  return /*#__PURE__*/React.createElement(ProjectFormsWrapper, null, /*#__PURE__*/React.createElement(HeadingContainer, null, /*#__PURE__*/React.createElement(PageHeading, {
    actions: headingActions,
    bottomBar: bottomBar
  }, pageHeadingMessage)), /*#__PURE__*/React.createElement(ListProjectForms, {
    projectType: projectType,
    projectKey: projectKey,
    simplifiedProject: simplifiedProject,
    userIsProjectAdmin: userIsProjectAdmin
  }));
};